import React from 'react';
import styled from 'styled-components';
import SectionHeader from '../common/SectionHeader';

const FilterSection = styled.section`
  padding: 60px 0 30px;
`;

const FilterButtons = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 15px;
  margin-top: 30px;
`;

const FilterButton = styled.button`
  padding: 10px 20px;
  background-color: ${props => 
    props.active ? props.theme.colors.primaryColor : props.theme.colors.lightColor};
  color: ${props => 
    props.active ? props.theme.colors.white : props.theme.colors.secondaryColor};
  border: none;
  border-radius: ${props => props.theme.borders.radius.small};
  font-weight: ${props => props.theme.fontWeights.semiBold};
  cursor: pointer;
  transition: ${props => props.theme.transitions.main};
  font-family: ${props => props.theme.fonts.primary};
  font-size: ${props => props.theme.fontSizes.regular};
  
  &:hover {
    background-color: ${props => 
      props.active ? props.theme.colors.primaryColor : props.theme.colors.grey[300]};
  }
  
  &:focus {
    outline: none;
  }
`;

const PortfolioFilter = ({ activeFilter = 'all', onFilterChange }) => {
  const filters = [
    { id: 'all', label: 'All' },
    { id: 'projects', label: 'Projects' },
    { id: 'success-stories', label: 'Success Stories' },
    { id: 'research', label: 'Research' },
    { id: 'awards', label: 'Awards & Recognition' }
  ];

  const handleFilterClick = (filterId) => {
    if (onFilterChange) {
      onFilterChange(filterId);
    }
  };

  return (
    <FilterSection>
      <div className="container">
        <SectionHeader 
          title="Our Projects and Achievements" 
          subtitle="Explore our work, student success stories, and research projects" 
        />
        
        <FilterButtons>
          {filters.map(filter => (
            <FilterButton 
              key={filter.id} 
              active={activeFilter === filter.id}
              onClick={() => handleFilterClick(filter.id)}
              data-filter={filter.id}
            >
              {filter.label}
            </FilterButton>
          ))}
        </FilterButtons>
      </div>
    </FilterSection>
  );
};

export default PortfolioFilter;
